/**
 * Integrytas Group - CSM. A locale <select> that shows language NAMES (§17.B4),
 * sourced from useLanguageOptions. Stores/emits the locale CODE. Preserves an
 * already-set value even if that locale is now inactive.
 */
import { useTranslation } from 'react-i18next';
import { useLanguageOptions } from '../../lib/use_language_options';
import { localeName } from '../../i18n/locale_display';

export interface LocaleSelectProps {
  value: string | null;
  onChange: (code: string) => void;
  disabled?: boolean;
  allowEmpty?: boolean;
  className?: string;
}

export function LocaleSelect({ value, onChange, disabled, allowEmpty, className }: LocaleSelectProps) {
  const { t } = useTranslation();
  const { options, loading } = useLanguageOptions();
  const known = options.some(o => o.code === value);
  return (
    <select
      value={value ?? ''}
      disabled={disabled || loading}
      onChange={e => onChange(e.target.value)}
      className={className ?? 'h-8 w-full rounded border border-csm-border px-2 text-csm-md focus:border-csm-watermark focus:outline-none'}
    >
      {allowEmpty && <option value="">{t('common.locale_select.none', '(none)')}</option>}
      {value && !known && <option value={value}>{localeName(value, value)}</option>}
      {options.map(o => <option key={o.code} value={o.code}>{o.name}</option>)}
    </select>
  );
}
